import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 4,
  class: "maintenance-checking"
}
const _hoisted_2 = {
  key: 5,
  class: "maintenance-test-banner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_MaintenanceScreen = _resolveComponent("MaintenanceScreen")!
  const _component_MaintenanceTesterLogin = _resolveComponent("MaintenanceTesterLogin")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_config_provider, { locale: _ctx.locale }, {
      default: _withCtx(() => [
        (_ctx.isMaintenanceAccessRoute)
          ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
          : (_ctx.maintenanceReady && _ctx.maintenanceBlocked && !_ctx.testerLogin)
            ? (_openBlock(), _createBlock(_component_MaintenanceScreen, {
                key: 1,
                config: _ctx.maintenanceConfig,
                checking: _ctx.maintenanceChecking,
                onRefresh: _ctx.refreshMaintenance,
                onTesterLogin: _ctx.beginTesterLogin
              }, null, 8, ["config", "checking", "onRefresh", "onTesterLogin"]))
            : (_ctx.maintenanceReady && _ctx.maintenanceBlocked && _ctx.testerLogin)
              ? (_openBlock(), _createBlock(_component_MaintenanceTesterLogin, {
                  key: 2,
                  checking: _ctx.testerChecking,
                  onAuthenticated: _ctx.verifyTesterLogin,
                  onCancel: _ctx.exitMaintenanceTest
                }, null, 8, ["checking", "onAuthenticated", "onCancel"]))
              : (_ctx.maintenanceReady)
                ? (_openBlock(), _createBlock(_component_router_view, { key: 3 }))
                : (_openBlock(), _createElementBlock("div", _hoisted_1, "正在检查系统状态...")),
        (_ctx.testerAllowed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createTextVNode("维护测试中 "),
              _createVNode(_component_a_button, {
                size: "small",
                onClick: _ctx.exitMaintenanceTest
              }, {
                default: _withCtx(() => [
                  _createTextVNode("退出维护测试")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["locale"])
  ]))
}